<template>
  <div>
    <b-table :items="evaluationsDates"
             bordered
             class="table-responsive"
             responsive
             striped
             thead-class="d-none">
    </b-table>
  </div>
</template>

<script>
  import { infrastructureMixin } from '@/mixins/infrastructure';
  import { reviewsDetails } from '@/mixins/reviewsDetails';

  export default {
    name: 'RapidAccessGradeDatesTable',
    mixins: [infrastructureMixin, reviewsDetails],
    props: {
      proposal: {
        type: Object,
        default: () => ({}),
      },
    },
    computed: {
      canIncludeReviewsAndFinalGrade() {
        return this.proposal.general.rapid_access_subtype === 'Scientific merit';
      },
      basicEvaluationsDates() {
        return [
          {
            title: 'Safety evaluation submission date',
            date: this.proposal.samples[0].safety_evaluation?.states.name === 'submitted'
              ? this.proposal.samples[0].safety_evaluation.states.date
              : '',
          },
          {
            title: 'Radiation evaluation submission date',
            date: this.proposal.samples[0].radiation_evaluation?.states.name === 'submitted'
              ? this.proposal.samples[0].radiation_evaluation.states.date
              : '',
          },
          {
            title: 'Technical evaluation submission date',
            date: this.proposal.technical_evaluation?.states.name === 'submitted'
              ? this.proposal.technical_evaluation.states.date
              : '',
          },
          {
            title: 'Management evaluation submission date',
            date: this.proposal.management_evaluation?.states?.name === 'submitted'
              ? this.proposal.management_evaluation?.states.date
              : '',
          },
        ];
      },
      reviewFirstReviewerDate() {
        return this.reviews?.[0]?.author ? [
          {
            title: this.reviewRowTitle(0),
            date: this.reviewRowData(0),
          },
        ] : [];
      },
      reviewSecondReviewerDate() {
        return this.reviews?.[1]?.author ? [
          {
            title: this.reviewRowTitle(1),
            date: this.reviewRowData(1),
          },
        ] : [];
      },
      finalGradeDate() {
        return [
          {
            title: 'Final grade submission date',
            date: this.proposal.final_grade?.states.name.includes('submitted')
              ? this.proposal.final_grade?.states.date
              : '',
          },
        ];
      },
      evaluationsDates() {
        if (this.canIncludeReviewsAndFinalGrade) {
          return [
            ...this.basicEvaluationsDates.slice(0, -1),
            ...this.reviewFirstReviewerDate,
            ...this.reviewSecondReviewerDate,
            ...this.finalGradeDate,
            this.basicEvaluationsDates[this.basicEvaluationsDates.length - 1],
          ];
        }
        return this.basicEvaluationsDates;
      },
      reviews() {
        return this.constructReviews(this.proposal);
      },
    },
    methods: {
      reviewRowTitle(index) {
        return `${this.reviews[index].author} review submission date`;
      },
      reviewRowData(index) {
        return this.reviews[index].states.name === 'submitted'
          ? this.reviews[index].states.date
          : '';
      },
    },
  };
</script>

<style lang="scss" scoped>

</style>
